import { orderByValue } from '@/util/collection/order-by-value'

export interface CartItemLike {
  id: string
}
export interface OrderLike {
  cartItems: CartItemLike[]
}
export interface OrderResultLike {
  order: OrderLike
}

/**
 * 注文結果のカート内商品順序が不定だった場合に備えて一度ソート。
 * 特に「不定」という仕様があるわけではないが、Engineバグが有った場合の影響を抑える意図。
 *
 * 徹底するなら「カート内商品の順番もソート」という手続きが必要になりそうだが、
 * 注文ごとのカート内商品表示が多少入れ替わっても、それほど影響は無いだろうと判断。
 * ↑をやろうとすると、「注文結果に対応する注文」をidなりで見つけた上で、各注文結果ごとにカート内商品を並び直しといった手続きが必要になり、
 * 効果に比べて手間がかかる。
 * @see https://github.com/my-color/front/pull/3941
 */
const toCartItemIdsStr = (o: OrderLike) => o.cartItems.map(c => c.id).sort().join('')
const compareOrder = (a: OrderLike, b: OrderLike) => toCartItemIdsStr(a) === toCartItemIdsStr(b)

export const sortOrderResultsByOrderList =
  <R extends OrderResultLike>(orderList: OrderLike[], results: R[]): R[] =>
    // 実行ごとに毎回複数の関数オブジェクトが生成されるが、
    // 数個の関数オブジェクトが致命的になるとも思えないので、単純であることを優先.
    // 実際にリソース上問題になるのであれば、finder/comparator注入済みの関数をクロージャで再利用する.
    orderByValue<R, OrderLike>(r => r.order)(compareOrder)(results, orderList)
